// src/routes/routeConstants.js
export const routeConstants = {
	login: 'login',
	accountRecovery: 'account-recovery',
	createNewPassword: 'create-new-password',
	activateAccount: 'activate-account',
	createNewPasswordExpired: 'create-new-password-expired',
	root: '/',
	dashboard: 'dashboard',
	pageNotFound: '*',
	auth: 'auth',
	initiations: 'dashboard/initiations',
	academic: 'dashboard/academic',
	assessment: 'dashboard/assessment',
}

export const routePaths = {
	login: '/auth/login',
	accountRecovery: '/auth/account-recovery',
	createNewPassword: '/auth/create-new-password',
	createNewPasswordExpired: '/auth/create-new-password-expired',
	activateAccount: '/auth/activate-account',
	home: '/dashboard/home',
	counsellors: '/dashboard/counsellors',
	deactivatedUsers: '/dashboard/deactivated-users',
	academicSchools: '/dashboard/academic/schools',
	academicClassrooms: '/dashboard/academic/classrooms',
	academicStudents: '/dashboard/academic/students',
	academicTeachers: '/dashboard/academic/teachers',
	initiationsIndividualCase: '/dashboard/initiations/individualCase',
	initiationsObservation: '/dashboard/initiations/observation',
	initiationsObservationLog: '/dashboard/initiations/observation-log',
	initiationsObservationLogAdd: '/dashboard/initiations/observation-log/add',
	initiationsBaseline: '/dashboard/initiations/baseline',
	initiationsStudentBaseline: '/dashboard/initiations/baseline',
	initiationsBaselineAnalyticsReport: '/dashboard/initiations/baseline',
	initiationsSELCurriculumTracker:
		'/dashboard/initiations/SELCurriculumTracker',
	initiationsAddSELCurriculumTracker:
		'/dashboard/initiations/SELCurriculumTracker/addSELCurriculumTracker',
	initiationsEditSELCurriculumTracker:
		'/dashboard/initiations/SELCurriculumTracker/editSELCurriculumTracker',
	initiationsViewSELCurriculumTracker:
		'/dashboard/initiations/SELCurriculumTracker/ViewSELCurriculumTracker',
	selTemplateAdmin: '/dashboard/SELCurriculumTracker/templates',
	initiationsStudentCope: '/dashboard/assessment/studentCopeAssessment',
	initiationsStudentCopeDetailsPage:
		'/dashboard/assessment/studentCopeAssessment/studentCOPE',
	schoolCOPEAnalyticsReport: '/dashboard/assessment/studentCopeAssessment',
	specificSchoolCOPEAnalytics:
		'/dashboard/assessment/studentCopeAssessment/School COPE Analytics',

	assessmentTeacherIRI: '/dashboard/assessment/TeacherIRI',
	assessmentTeacherIRITeachersList: '/dashboard/assessment/TeacherIRI',
	assessmentTeacherIRIAssessment:
		'/dashboard/assessment/TeacherIRI/teacherDetails',
	schoolIRIAnalyticsReport: '/dashboard/assessment/TeacherIRI',
	specificSchoolIRIDetails:
		'/dashboard/assessment/TeacherIRI/specificSchoolIRIDetails',

	TeacherProfilingAssessment: '/dashboard/assessment/TeacherProfiling',
	TeacherProfilingAssessmentDetails:
		'/dashboard/assessment/TeacherProfiling/teacherDetails',
	specificSchoolProfilingDetails:
		'/dashboard/assessment/TeacherProfiling/specificSchoolProfilingDetails',
	schoolProfilingAnalyticsReport:
		'/dashboard/assessment/TeacherProfiling/Analytics',
	assessmentIndex: 'dashboard/assessment',
	initiationsstudentWellBeing: '/dashboard/assessment/studentWellBeing',
	specificStudentWellBeing: '/dashboard/assessment/studentWellBeing',
	studentWellBeingAnalyticsSchools:
		'/dashboard/assessment/studentWellBeing/analytics',
	initiationsSendChecklist: '/dashboard/initiations/sendChecklist',
	AddStudentChecklist: '/dashboard/initiations/sendChecklist/addStudent',
	studentChecklistAnalytics: '/dashboard/initiations/sendChecklist/analytics',
	initiationsIEP: '/dashboard/initiations/IEP',
	initiationsBip: '/dashboard/initiations/bip',
	initiationsBipNew: '/dashboard/initiations/bip/new',
	initiationsAddIEP: '/dashboard/initiations/IEP/addStudentIEPDetails',
	initiationsStudentIEP: '/dashboard/initiations/student-iep/:studentId',
	initiationsGandT: '/dashboard/initiations/gandt',
	gandtItapReport: '/dashboard/initiations/gandt/report',
	gandtTemplates: '/dashboard/initiations/gandt/templates',
	gandtTemplateAdd: '/dashboard/initiations/gandt/templates/add',
	gandtTemplateEdit: '/dashboard/initiations/gandt/templates/edit',
	gandtTemplateView: '/dashboard/initiations/gandt/templates/view',
	gandtAssignments: '/dashboard/initiations/gandt/assignments',
	gandtAssignmentAdd: '/dashboard/initiations/gandt/assignments/add',
	gandtAssignmentEdit: '/dashboard/initiations/gandt/assignments/edit',
	teacherMsgPage: '/dashboard/teacherMsgPage',
	studentSelfAssessment: '/student-self-assessment',
	initiationsSelfAssessmentDashboard:
		'/dashboard/initiations/self-assessment-dashboard',
	schoolProgress: '/dashboard/initiations/school-progress',
	inclusionProgress: '/dashboard/initiations/inclusion-progress',
	// new assessments
	newAssessmentSafeSpaces: '/dashboard/assessment/safe-spaces',
	newAssessmentSELCompetency: '/dashboard/assessment/sel-competency',
	newAssessmentPulse: '/dashboard/assessment/pulse',
	newAssessmentHeart: '/dashboard/assessment/heart-educators',
	aiIep: '/dashboard/ai-iep',

	// Super Admin — Roles & Permissions
	rolePermissions: '/dashboard/settings/roles-permissions',
	systemConfiguration: '/dashboard/settings/system-configuration',
	schoolConfiguration: '/dashboard/settings/school-configuration',
	backupLogs: '/dashboard/settings/backup-logs',
	activityAudit: '/dashboard/settings/activity-audit',
	activityAuditUser: '/dashboard/settings/activity-audit/user/:userId',
	counsellorRegistrationList: '/dashboard/settings/counsellor-registrations',
	websiteInquiries: '/dashboard/settings/website-inquiries',
	counsellorRegistrationDetail: '/dashboard/settings/counsellor-registrations/:id',
	counsellorRegistrationPublicForm: '/counsellor-registration',
	counsellorFeedbackAdmin: '/dashboard/settings/counsellor-feedback',

	studentSupportOverview: '/dashboard/student-support/overview',
	studentSupportSessions: '/dashboard/student-support/sessions',
	studentSupportSessionDetail: '/dashboard/student-support/sessions/:id',
	studentSupportRequests: '/dashboard/student-support/requests',
	helpCenterSosAdmin: '/dashboard/settings/help-center-sos',

	// Virtual Counselling
	virtualCounsellingSessions: '/dashboard/virtual-counselling/sessions',
	// virtualCounsellingSchoolPortal: '/dashboard/virtual-counselling/sessions/school',
	// virtualCounsellingSchoolLogin: '/dashboard/virtual-counselling/sessions/school/login',
	// virtualCounsellingSchoolDashboard: '/dashboard/virtual-counselling/sessions/school/dashboard',
	virtualCounsellingSchoolPortal: '/school-portal/live',
virtualCounsellingSchoolLogin: '/school-portal/login',
virtualCounsellingSchoolDashboard: '/school-portal/dashboard',
	virtualCounsellingManageSchools: '/dashboard/virtual-counselling/sessions/manage-schools',
	virtualCounsellingCounsellorPortal: '/dashboard/virtual-counselling/sessions/counsellor',
	virtualCounsellingSessionHistory: '/dashboard/virtual-counselling/sessions/history',
	virtualCounsellingSchedule: '/dashboard/virtual-counselling/schedule',

	virtualCounsellingReports: '/dashboard/virtual-counselling/reports',

	virtualCounsellingChat: '/dashboard/virtual-counselling/chat-support',

	// Safe Space Survey (LiveKit + 18Q coverage) — MyPeegu Expert / Super Admin
	safeSpaceSurveyHub: '/dashboard/safe-space-survey',
	safeSpaceSurveyCreate: '/dashboard/safe-space-survey/create',
	safeSpaceSurveySessions: '/dashboard/safe-space-survey/sessions',
	safeSpaceSurveyHistory: '/dashboard/safe-space-survey/history',
	safeSpaceSurveyDetail: '/dashboard/safe-space-survey/sessions/:sessionId',
	safeSpaceSurveyReport: '/dashboard/safe-space-survey/report/:sessionId',
	safeSpaceSurveyDashboard: '/dashboard/safe-space-survey/dashboard',

	// Resource Management (Super Admin)
	rmsDashboard: '/dashboard/resources',
	rmsList: '/dashboard/resources/list',
	rmsUpload: '/dashboard/resources/upload',
	rmsPublicShare: '/resource/share/:token',
}
